'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminDashboardController', ['$scope', '$http', '$q', function($scope, $http, $q) {

  $scope.stats           = { publications: 0, contrats: 0, autorisations: 0, users: 0 };
  $scope.recentActivities = [];
  $scope.loadingActivity  = true;
  $scope.lastUpdate       = new Date();

  var ACTION_MAP = {
    'CREATE': { label: 'Création',     badgeClass: 'adm-badge adm-badge-success', dotClass: 'create' },
    'UPDATE': { label: 'Modification', badgeClass: 'adm-badge adm-badge-info',    dotClass: 'edit'   },
    'DELETE': { label: 'Suppression',  badgeClass: 'adm-badge adm-badge-danger',  dotClass: 'delete' }
  };

  function loadStats() {
    $q.all([
      $http.get('/api/publications').catch(function() { return { data: [] }; }),
      $http.get('/api/contrats-petroliers').catch(function() { return { data: [] }; }),
      $http.get('/api/autorisations-recherche').catch(function() { return { data: [] }; }),
      $http.get('/api/admin/users?page=0&size=1').catch(function() { return { data: { totalElements: 0 } }; })
    ]).then(function(results) {
      var pubs  = results[0].data; $scope.stats.publications  = Array.isArray(pubs)  ? pubs.length  : (pubs.totalElements  || pubs.length  || 0);
      var cont  = results[1].data; $scope.stats.contrats      = Array.isArray(cont)  ? cont.length  : (cont.totalElements  || cont.length  || 0);
      var auth  = results[2].data; $scope.stats.autorisations = Array.isArray(auth)  ? auth.length  : (auth.totalElements  || auth.length  || 0);
      var users = results[3].data; $scope.stats.users         = users.totalElements  || 0;
    });
  }

  function loadActivity() {
    $scope.loadingActivity = true;
    $http.get('/api/admin/activity?size=8')
      .then(function(response) {
        $scope.recentActivities = (response.data || []).map(function(a) {
          var map = ACTION_MAP[a.action] || { label: a.action, badgeClass: 'adm-badge adm-badge-muted', dotClass: 'edit' };
          return angular.extend({}, a, { action: map.label, badgeClass: map.badgeClass, dotClass: map.dotClass });
        });
      })
      .catch(function() { $scope.recentActivities = []; })
      .finally(function() { $scope.loadingActivity = false; });
  }

  loadStats();
  loadActivity();
}]);
